import {
  INewUser,
  PlatformContextType
} from "@wingspanhq/users/dist/lib/interfaces/newUser";

export const selectorHasPayerContextUser = (user: INewUser) =>
  (user.contexts || []).some(
    context => context.type === PlatformContextType.Payer
  );
